import { render, staticRenderFns } from "./ListagemCompra.vue?vue&type=template&id=1a8e9649"
import script from "./ListagemCompra.vue?vue&type=script&lang=js"
export * from "./ListagemCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports